;
/*!
 * subitotexto.form.js
 *
 * Refactored by Michal on 2016-11-03
 * For a11y pruposes, not showing the errors next to each field.
 * Instead, gathering all errors and then setting them in a master error container.
 * Same with setting the aria-invalid attributes.
 * Trying to minimizes the amount of screen changes to make it easier for screen readers.
 *
 */
SubitoTexto.form = {

	init: function () {
		var $ = jqPla,
			_this = SubitoTexto.form;


		_this.$formResults = $( '.form-submission-results' );

		if ( _this.$formResults.length > 0 ) {
			_this.$formResults.on( 'click', '.error-message', function ( e ) {
				e.preventDefault();


				var $this = $( this ),
					href = $this.attr( 'href' ),
					$input = $( href ),
					$label = $( 'label[for="' + href.replace( '#', '' ) + '"]' );

				// Scroll the label into view,
				// otherwise scroll the input into view
				if ( $label.length > 0 ) {
					PLA.UTILS.scrollTop.scrollTo( $label, -10, 50 );
				} else {
					PLA.UTILS.scrollTop.scrollTo( $input, 10, 50 );
				}

				$input.focus();

			} );
		}
	},


	processForm: function ( $form, arrErrors, bAfter ) {
		var $ = jqPla,
			$fieldGroups = $form.find( '.field-group' ),
			$inputs = $fieldGroups.find( 'input, select, textarea' ),
			bAfter = (bAfter ? true : false),

			$formResults = $( '.form-submission-results' ),
			htmlErrors = [],
			$goodInputs,
			$badInputs = [];


		if ( arrErrors.length < 1 ) {
			return;
		}


		if ( $formResults.length < 1 ) {
			console.error( 'SUBITO_FORMS: You need to have a .form-submission-results container within the form' );
			return;
		}


		for ( var i = 0; i < arrErrors.length; i++ ) {
			var currError = arrErrors[ i ];

			// Globals aren't specific to an input
			if ( currError.key == 'global' ) {
				htmlErrors.push( '<div class="error-message">' + currError.message + '</div>' );
			} else {
				// Individual input errors will also include a link to be able to easily correct them
				htmlErrors.push( '<a class="error-message error-specific-input" href="#' + currError.key + '">' + currError.message + ' <span class="error-corriger">Corriger</span></a>' );

				//console.log( '$badInputs.length', $badInputs.length, $inputs.filter( '#' + currError.key ) )

				if ( $badInputs.length < 1 ) {
					$badInputs = $inputs.filter( '#' + currError.key );
				} else {
					$badInputs.add( $inputs.filter( '#' + currError.key ) );
				}


			}

		}

		$goodInputs = $inputs.not( $badInputs );

		//console.log('Errors:', errors, '$inputs', $inputs, '$goodInputs', $goodInputs, '$badInputs', $badInputs);


		var $errorsHtml = $formResults.html( htmlErrors.join( "\n" ) );

		if ( $goodInputs.length > 0 ) {
			$goodInputs.removeAttr( 'aria-invalid' );
		}

		if ( $badInputs.length > 0 ) {
			$badInputs.attr( 'aria-invalid', true );
		}


		var $firstInputError = $errorsHtml.find( '.error-specific-input' ).eq( 0 ),
			$anyError = $errorsHtml.find( '.error-message' ).eq( 0 );

		//console.log( '$anyError', $anyError );

		if ( $firstInputError.length > 0 ) {
			$firstInputError.focus();
		} else if ( $anyError.length > 0 ) {
			PLA.UTILS.scrollTop.scrollTo( $anyError, -10 );
		}

	}

};    // SubitoTexto.form
